<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
  <div class="mb-8 text-center">
    <h1 class="text-2xl md:text-4xl font-bold text-gray-900">
      Enabling the NDC Age for Travel Agencies
    </h1>
    <p class="md:text-xl mt-2 text-gray-600">
      Shop, Book and Service all your NDC content in one single platform
    </p>
    <div class="mt-4">
      <button type="button" class="btn btn-outline btn-md btn-primary" (click)="agencyLogin()">
        <i class="ri-login-box-line"></i>
        Agency Login
      </button>
      <button
        *ngIf="registerAvailable"
        type="button"
        class="btn btn-outline btn-md btn-primary ml-3"
        (click)="agencyRegistration()"
      >
        <i class="ri-user-add-line"></i>
        Agency Registration
      </button>
    </div>
  </div>

  <div
    class="mx-auto my-12 p-6 md:p-8 border border-gray-300 rounded shadow-sm bg-white flex flex-col md:flex-row gap-2 md:gap-8"
  >
    <div class="flex-1 pr-0 md:pr-6">
      <h2 class="flex items-center gap-2 text-red-700 font-semibold text-lg mb-3">
        <i class="ri-computer-line ri-xl"></i>
        Agent Desktop
      </h2>
      <p class="text-gray-900 font-bold mb-2 leading-relaxed">Ready to start using bookingpad?</p>
      <p class="text-gray-600 mb-4 leading-relaxed">
        Please note that in order to use our NDC Agency Desktop Solution you must have an account
        created and all the agency's credentials set up to receive airlines results.
      </p>
      <button type="button" class="btn btn-md btn-primary" (click)="bpLogin()">
        Log In to Bookingpad
      </button>
    </div>

    <div class="hidden md:block border-l border-gray-300"></div>
    <div class="block md:hidden border-t border-gray-300 my-6"></div>

    <div class="flex-1 pl-0 md:pl-6">
      <h2 class="flex items-center gap-2 text-red-700 font-semibold text-lg mb-3">
        <i class="ri-plug-line ri-xl"></i>
        API Developer Guide
      </h2>
      <p class="text-gray-600 mb-4 leading-relaxed">
        Read our API developer guide to get a brief idea on what our API can provide.
      </p>
      <button type="button" class="btn btn-outline btn-md btn-primary" (click)="readDocs()">
        Read the Docs
      </button>
    </div>
  </div>
</div>
